export default __webpack_public_path__ + "static/media/tiec-trang-mau-blood-moon-party-16021267739246.ffc36816.png";